import { render, staticRenderFns } from "./RelationReportMenu.vue?vue&type=template&id=71f8dc32&scoped=true"
import script from "./RelationReportMenu.vue?vue&type=script&lang=ts"
export * from "./RelationReportMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f8dc32",
  null
  
)

export default component.exports